import React, { Component } from 'react'
import Collapsible from '../Collapsible'
import CheckBox from '../../components/CheckBox'
import { numberWithCommas } from '../../utils/stringOps'
import { AOISTOIGNORE } from '../../utils/constants'

class FilterAreaOfInterest extends Component {
  aoiChanged = (isChecked, selectedValue) => {
    this.props.onAoiChanged(isChecked, selectedValue)
  }

  render () {
    var filterCategories = this.props.ignoreAois ?
                           this.props.filterCategories.filter(c => !AOISTOIGNORE.includes(c.id))
                           : this.props.filterCategories
    
    const filterAois = filterCategories.filter(c => c.type === 20)
      .map(c => { return { id: c.id, name: c.name, resultCount: c.resultCount } })
      .sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name))

    return (
      (filterAois.length > 0) ?
      <Collapsible title='Area of Interest' titleClassName='box-header' id='aoi' open>
          <div className='div-separator'>
            <CheckBox
              id='cbAoiAll'
              Name='cbAoiAll'
              Checked={this.props.selectedAois.length === 0}
              onTickChanged={(chk, val) => this.aoiChanged(chk, val)}
              Value='0' text='Show All'
            />
          </div>

          {filterAois.map(content =>
            (
              <div key={content.id} className='filter-values'>
                <CheckBox
                  id={'cbAoi' + content.id}
                  Name={'cbAoi' + content.id}
                  Checked={this.props.selectedAois.includes(content.id)}
                  onTickChanged={(chk, val) => this.aoiChanged(chk, val)}
                  Value={content.id} text={content.name}
                />
                <div>{content.resultCount > 9999 ? '9,999+' : numberWithCommas(content.resultCount)}</div>
              </div>
            ))}
      </Collapsible>
      : null
    )
  }
}

export default FilterAreaOfInterest
